import { FC, useMemo } from 'react';
import styles from './AppliedFilterSummary.module.css';
import { useCategories } from '../hooks/useCategories';
import { AppliedFilterChip, BrowseFilterState, getAppliedFilterChips } from '../utils/filterUtils';

interface AppliedFilterSummaryProps {
  filters: BrowseFilterState;
  onRemoveChip: (chip: AppliedFilterChip) => void;
  onClearAll: () => void;
}

const AppliedFilterSummary: FC<AppliedFilterSummaryProps> = ({ filters, onRemoveChip, onClearAll }) => {
  const { categories } = useCategories();

  const categoryNameBySlug = useMemo(() => {
    return new Map(categories.map((category) => [category.slug, category.name]));
  }, [categories]);

  const chips = useMemo(() => {
    return getAppliedFilterChips(filters, categoryNameBySlug);
  }, [filters, categoryNameBySlug]);

  if (chips.length === 0) {
    return null;
  }

  return (
    <div className={styles.summary} aria-label="Filtres actifs">
      <div className={styles.chips}>
        {chips.map((chip) => (
          <button
            key={`${chip.key}-${chip.value ?? chip.label}`}
            type="button"
            className={styles.chip}
            onClick={() => onRemoveChip(chip)}
            aria-label={`Retirer le filtre ${chip.label}`}
          >
            <span>{chip.label}</span>
            <span className={styles.chipClose} aria-hidden="true">×</span>
          </button>
        ))}
      </div>
      <button type="button" className={styles.clearAll} onClick={onClearAll}>
        Tout effacer
      </button>
    </div>
  );
};

export default AppliedFilterSummary;
